import { staticPageService } from 'core/services/static-page/static-page.service';
import { type TSliceExtraReducer } from 'core/store';
import { getCustomerIdFromCheckout } from 'core/store/checkout/checkout-state.utils';
import { createAppAsyncThunk } from 'core/store/store.utils';
import { SLICE_NAMESPACE } from '../constants';
import { IStaticPagesState } from '../types';

export const getStaticPagesSections = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/getStaticPageSections`,
  async (_, { getState }) => {
    const state = getState();
    const { checkout } = state;

    const customerId = getCustomerIdFromCheckout(checkout);
    const { sections } = await staticPageService.getStaticSections(customerId);
    return sections;
  },
);

export const getStaticPagesSectionsReducer: TSliceExtraReducer<IStaticPagesState> = builder => {
  builder
    .addCase(getStaticPagesSections.pending, state => {
      state.sections.loading = true;
    })
    .addCase(getStaticPagesSections.fulfilled, (state, { payload }) => {
      state.sections.data = payload;
      state.sections.loading = false;
    })
    .addCase(getStaticPagesSections.rejected, state => {
      state.sections.data = [];
      state.sections.loading = false;
    });

  return builder;
};
